export const calcInstallment = (principal: number, installments = 12, withoutInterest = false) => {
  if (withoutInterest) {
    const value = principal / installments;
    return Math.round(value * 100) / 100;
  }

  const i = 0.0349;
  const pow = Math.pow(1 + i, installments);

  const value = principal * ((pow * i) / (pow - 1));

  return Math.round(value * 100) / 100;
};

export const formatBrlMoney = (value = 0) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  }).format(value > 0 ? value : 0);
};

export const isValidCPF = (cpf: string) => {
  cpf = cpf.replace(/[^\d]+/g, '');

  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
    return false;
  }

  let sum = 0;

  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i);
  }

  let firstCheckDigit = (sum * 10) % 11;

  if (firstCheckDigit === 10 || firstCheckDigit === 11) {
    firstCheckDigit = 0;
  }

  if (firstCheckDigit !== parseInt(cpf.charAt(9))) {
    return false;
  }

  sum = 0;

  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i);
  }

  let secondCheckDigit = (sum * 10) % 11;

  if (secondCheckDigit === 10 || secondCheckDigit === 11) {
    secondCheckDigit = 0;
  }

  if (secondCheckDigit !== parseInt(cpf.charAt(10))) {
    return false;
  }

  return true;
};

export const isValidCNPJ = (cnpj: string) => {
  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;

  const weightsFirstCheck = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const weightsSecondCheck = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  let sum = 0;

  for (let i = 0; i < 12; i++) {
    sum += parseInt(cnpj.charAt(i)) * weightsFirstCheck[i];
  }

  let firstCheckDigit = sum % 11;
  firstCheckDigit = firstCheckDigit < 2 ? 0 : 11 - firstCheckDigit;

  if (firstCheckDigit !== parseInt(cnpj.charAt(12))) {
    return false;
  }

  sum = 0;

  for (let i = 0; i < 13; i++) {
    sum += parseInt(cnpj.charAt(i)) * weightsSecondCheck[i];
  }

  let secondCheckDigit = sum % 11;
  secondCheckDigit = secondCheckDigit < 2 ? 0 : 11 - secondCheckDigit;

  if (secondCheckDigit !== parseInt(cnpj.charAt(13))) {
    return false;
  }

  return true;
};

export const scrollToElement = (element: HTMLInputElement | HTMLTextAreaElement | null) => {
  element?.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });

  element?.focus();
};
